import ReactECharts from "echarts-for-react"

import { useState, useEffect } from 'react'

import SelectionData from "../../interfaces/Graphs/SelectionData";
import GraphData from "../../interfaces/Graphs/GraphData";
import GraphService_DN from "../../services/GraphService_DN";
import './GraphStyles.css';

import { getRegions, getYears } from "../../interfaces/traffic_accidents/FormControllerData";

import GraphController from "./GraphController";
import { useTranslation } from "react-i18next";
import { MdLocalPolice } from "react-icons/md";

interface GraphProps {
    baseUrl_API: string,
    GraphData: GraphData[],
    GraphSeriesName: string,
    isAnimals?: boolean,
    minYear?: number,
    title?: string,
    graphName?: string
}


const RegionName = "Region";
const YearName = "Year";

export default function GraphComponent(props: GraphProps) {
    const { t } = useTranslation(["traffic", "crimes"]);
    const [IsLoadingData, SetIsLoadingData] = useState<boolean>(false);
    //const [Regions] = useState<SelectionData[]>(getRegions());
    //const [Years] = useState<SelectionData[]>(getYears());
    const [Data, SetData] = useState<number[]>(props.GraphData.map(item => item.Data));
    const [axisData, SetAxisData] = useState<string[]>(props.GraphData.map((item) => item.Title));
    const barOption = {
        ...(props.isAnimals && props.title ? {
            title: {
                text: props.title,
                left: 'center',
                top: 65,
                textStyle: {
                    fontSize: 22,
                    fontWeight: 'bold'
                }
            }
        } : {}),
        legend: props.isAnimals ? { show: false } : { top: "bottom" },
        tooltip: {},
        toolbox: {
            show: true,
            orient: "vertical",
            left: "right",
            top: "center",
            feature: {
                mark: { show: true },
                dataView: { show: true, readOnly: false },
                saveAsImage: { show: true },
            },
        },
        grid: props.isAnimals ? {
            top: '30%',
            bottom: 90,
            left: '12%',
            right: '8%'
        } : undefined,
        xAxis: {
            type: "category",
            data: axisData,
            axisLabel: props.isAnimals ? {
                show: true,
                interval: 0,
                overflow: "break",
                width: 67,
                fontSize: 10,
                lineHeight: 12,
                formatter: (value: string) => {
                    const words = value.split(' ');
                    const lines: string[] = [];
                    let current = '';
                    for (const word of words) {
                        const test = current ? current + ' ' + word : word;
                        if (test.length > 10 && current) {
                            lines.push(current);
                            current = word;
                        } else {
                            current = test;
                        }
                        if (lines.length === 3) break;
                    }
                    if (lines.length < 3 && current) lines.push(current);
                    return lines.join('\n');
                },
            } : undefined,
            ...(props.isAnimals && props.graphName ? {
                name: props.graphName,
                nameLocation: 'middle',
                nameGap: 60,
                nameTextStyle: { fontSize: 13, fontWeight: 'bold' }
            } : {})
        },
        yAxis: {
            type: "value",
            ...(props.isAnimals ? {
                name: props.GraphSeriesName,
                nameLocation: 'middle',
                nameGap: 70,
                nameRotate: 90,
                nameTextStyle: { fontSize: 13, fontWeight: 'bold' }
            } : {})
        },
        series: [
            {
                name: props.GraphSeriesName,
                data: Data,
                type: "bar",
                label: props.isAnimals ? {
                    show: true,
                    position: "top",
                } : undefined,
            },
        ],
    };

    useEffect(() => {
        SetAxisData(props.GraphData.map(item => item.Title));
    },[props.GraphData]);

    const filteredYears = props.minYear 
        ? getYears().filter(year => parseInt(year.Code) >= props.minYear!)
        : getYears();

    const GraphControllerProps =
        [
            {
                label: t("Graph.regiony"),//"Regióny",
                useIterval: false,
                selectionData: getRegions(),
                name: RegionName
            },
            {
                label: t("Graph.roky"),
                useIterval: true,
                selectionData: filteredYears,
                name: YearName
            }
        ];
    function FetchApi(data_url: string) {
        SetIsLoadingData(true);
        GraphService_DN.FetchDataFrom_API(data_url)
            .then((res: any) => {
                if (res.data !== undefined) {
                    if (Array.isArray(res.data)) {
                        let data: GraphData[] = GraphService_DN.AssignDataArray(res.data, props.GraphData);
                        // Sort by Data value descending if it's animals graph
                        if (props.isAnimals) {
                            data = data.filter(item => item.Data > 0);
                            data.sort((a, b) => b.Data - a.Data);
                            data = data.slice(0, 10);
                            SetAxisData(data.map(item => item.Title));
                        }
                        SetData(data.map(item => item.Data));
                    }
                    else {
                        let data: GraphData[] = GraphService_DN.AssignData(res.data, props.GraphData);
                        // Sort by Data value descending if it's animals graph
                        if (props.isAnimals) {
                            data = data.filter(item => item.Data > 0);
                            data.sort((a, b) => b.Data - a.Data);
                            data = data.slice(0, 10);
                            SetAxisData(data.map(item => item.Title));
                        }
                        SetData(data.map(item => item.Data));
                    }
                }
                SetIsLoadingData(false);
            })
            .catch((e: any) => {
                console.log(e);
                SetIsLoadingData(false);
            });
    }

    const FetchGraphData = (data_url: string) => {
        console.log(process.env.REACT_APP_API_URL_DN + `${data_url}`);
        FetchApi(data_url);
    };


    function GenerateUrl(state: any) {
        let region_data_url = "";
        let year_data_url = "";
        switch (state[RegionName].Option) {
            case 0:
                region_data_url = "all";
                break;
            case 1:
                region_data_url = state[RegionName].Data[0];
                break;
            case 2:
                region_data_url = state[RegionName].Data[0];
                break;
            default:
                region_data_url = "all";
                break;
        }
        switch (state[YearName].Option) {
            case 0:
                if (region_data_url === "all") {
                    year_data_url = "all";
                }
                else {
                    year_data_url = "-1";
                }
                break;
            case 1:
                let code = "-1";
                if (state[YearName].Data[0] !== "all") {
                    code = state[YearName].Data[0];
                }
                year_data_url = code;
                break;
            case 2:
                // For interval, we'll handle multiple years in onClick
                year_data_url = state[YearName].Data[0];
                break;
            default:
                year_data_url = "all";
                break;
        }
        
        // Handle animals endpoints using isAnimals prop
        if (props.isAnimals) {
            const animalUrl = `/${props.baseUrl_API}/animals/${region_data_url}/${year_data_url}`;
            return animalUrl;
        }
        
        const normalUrl = `/${props.baseUrl_API}/${region_data_url}/${year_data_url}`;
        return normalUrl;
    }

    const FetchIntervalData = async (state: any) => {
        SetIsLoadingData(true);
        
        try {
            let aggregatedData: GraphData[] = [];
            const years = state[YearName].Data;
            
            // Process each year in the interval
            for (let i = 0; i < years.length; i++) {
                const yearState = {
                    ...state,
                    [YearName]: {
                        ...state[YearName],
                        Option: 1, // Use MultiSelect option for single year
                        Data: [years[i]]
                    }
                };
                
                const yearUrl = GenerateUrl(yearState);
                console.log(`Fetching data for year ${years[i]}:`, yearUrl);
                
                const yearResponse = await GraphService_DN.FetchDataFrom_API(yearUrl);
                
                if (yearResponse.data !== undefined) {
                    let yearData: GraphData[];
                    if (Array.isArray(yearResponse.data)) {
                        yearData = GraphService_DN.AssignDataArray(yearResponse.data, props.GraphData);
                    } else {
                        yearData = GraphService_DN.AssignData(yearResponse.data, props.GraphData);
                    }
                    
                    // Initialize aggregatedData with first year's structure
                    if (i === 0) {
                        aggregatedData = yearData.map(item => ({
                            Title: item.Title,
                            Code: item.Code,
                            Data: item.Data
                        }));
                    } else {
                        // Aggregate the data by summing values for each code
                        aggregatedData.forEach((item, index) => {
                            if (yearData[index]) {
                                item.Data += yearData[index].Data;
                            }
                        });
                    }
                }
            }
            
            if (props.isAnimals) {
                aggregatedData = aggregatedData.filter(item => item.Data > 0);
                aggregatedData.sort((a, b) => b.Data - a.Data);
                SetAxisData(aggregatedData.map(item => item.Title));
            }
            
            SetData(aggregatedData.map(item => item.Data));
            SetIsLoadingData(false);
        } catch (error) {
            SetIsLoadingData(false);
        }
    }

    const onClick = async (state: any) => {
                
        // Check if it's interval select for years with multiple years
        if (state[YearName].Option === 2 && Array.isArray(state[YearName].Data) && state[YearName].Data.length > 1) {
            console.log('Processing interval with years:', state[YearName].Data);
            await FetchIntervalData(state);
        } else {
            let data_url = GenerateUrl(state);
            console.log('Generated URL:', data_url);
            FetchGraphData(data_url);
        }
    };

    return (
        <div className='box-12'>
            <GraphController GraphControls={GraphControllerProps} OnClick={onClick} isAnimals={props.isAnimals} />
            <div className="graph_wrapper">
                { IsLoadingData && <div className="loading">
                    <div><MdLocalPolice /> {t("Traffic.loading")}</div>
                </div> }
            
                <ReactECharts option={barOption} notMerge={true} style={props.isAnimals ? { height: '520px' } : undefined} />
            </div>

        </div>
    );
}
